import React from 'react';
import './Yeast.css'
import Yeastimg from '../../assets/images/Yeast.png'
import { useTranslation } from 'react-i18next';

function Yeast() {
  const { t } = useTranslation();

  const products = [
 
   
      {
        name: t('LIOZIMAS 4DRY'),
        description: t('Saccharomyces bayanus yeast is suitable for refermentations or second fermentations, thanks to its fructosophilic properties. Its technological characteristics of vigor, osmotolerance and adaptability to a wide range of temperatures make it a yeast suitable for the production of sparkling wines'),
      },
      {
        name: t('LIOZIMAS Arom'),
        description: t('Saccharomyces cerevisiae yeast selected for its ability to produce white wines rich in fruity and floral aromas. It is able to favor the expression of varietal aromas and give volume and softness. It is characterized by a good prevalence and a regular trend of fermentation.'),
      },
      {
        name: t('LIOZIMAS B'),
        description: t('Saccharomyces cerevisiae bayanus yeast, with excellent fermentation characteristics and resistance to alcohol, suitable for the production of white, rosé and red wines even in difficult conditions. Suitable for fermentation restarts. The excellent prevalence and the regular fermentation process until the sugars are exhausted make it possible to obtain technically correct wines.'),
      },
      {
        name: t('LIOZIMAS Dynamic white'),
        description: t('LIOZIMAS Dynamic white is a Saccharomyces yeast strain for the fermentation of white wines with a dynamic, modern and elegant style. Particularly recommended for the production of fresh wines, enhancing the minerality.'),
      },
      {
        name: t('LIOZIMAS ST113'),
        description: t('Saccharomyces cerevisiae yeast selected for its ability to produce great complex white wines, full-bodied and suitable for long refinements. It enhances thiol aromas and produces a high quantity of esters attributable to tropical fruit.'),
      },
      {
        name: t('LIOZIMAS Vigor'),
        description: t('LIOZIMAS VIGOR is an active dry yeast from Saccharomyces cerevisiae selected for its characteristics of fermentative vigor and safety thanks to its superiority over indigenous yeasts. Particularly suitable for the primary fermentation of any type of vine thanks to respect for the varietal.'),
      },
      {
        name: t('LIOZIMAS Cru'),
        description: t('Saccharomyces cerevisiae yeast selected for its ability to produce fine red wines characterized by notable softness, coming from grapes rich in tannins and anthocyanins, respecting the aromatic typicality.It is characterized by a good prevalence and a regular trend of fermentation even with long macerations'),
      },
      {
        name: t('LIOZIMAS Primavera'),
        description: t('Liozimas Primavera is a yeast strain selected for the vinification of fresh and modern-style rosés, thanks to its excellent ability to produce fermentative aromas attributable to fresh fruit, pink grapefruit, pomegranate and spring flowers'),
      },
      {
        name: t('LIOZIMAS Red Flavours'),
        description: t('Yeast Saccharomyces cerevisiae alcoholic, vigorous and with a short latent phase. It contributes to the production of soft wines thanks to a good production of glycerol and a bouquet with pleasant aromatic notes highlighted by hints of berries.'),
      },
      {
        name: t('LIOZIMAS Spirit'),
        description: t('LIOZIMAS Spirit is a S. cerevisiae yeast specially selected for the fermentation of masses intended for the production of distillates.'),
      },
      {
        name: t('LIOZIMAS TH4'),
        description: t('TH4 is an active dry yeast Saccharomyces cerevisiae selected for the fermentation of wines with high aromatic intensity, as it has a high detection capacity of 4MMP, 3MH and A3MH attributable to passion fruit, pineapple, grapefruit and broom, which are intense and stable over time.'),
      },
      {
        name: t('LIOZIMAS White flavours'),
        description: t('Saccharomyces cerevisiae yeast capable of fermenting in difficult conditions with low temperatures and in a reduction state where it enhances the floral aromas.It increases the production of polysaccharides, thus making an important contribution to the gustatory complexity, harmony and sensorial stability of the wine.'),
      },
      {
        name: t('LIOZIMAS Harmony red'),
        description: t('Harmony Red is a Saccharomyces cerevisiae yeast for the fermentation of harmonious and elegant, free-flowing and balanced red wines. The moderate fermentation kinetics make it ideal for fermenting wines such as Pinot Noir, Sangiovese Merlot and Syrah.'),
      },
      // {
      //   name: t('Rosso'),
      //   description: t('masala ar aris ! '),
      // },
     
  ];

  return (
  <>

<div className='mainYeastImg'>
  <div className='YeastImg1'></div>

  <div className="YeastImg2">
    <h1 className="YeastTitle">{t("Yeast")}</h1>
    <img src={Yeastimg} alt="Yeast" className="YeastImage" />
  </div>
</div>

    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default Yeast;
